import { computed, observable } from "mobx";
import Person from "./person";

export default class NaturalPerson extends Person {
  @observable
  isRepresentedByProxy = false;

  @computed
  get validateFullName() {
    return !!this.mailingAddress || !!this.birthDate;
  }

  @computed
  get validateAddress() {
    return !!this.fullName || !!this.birthDate;
  }

  @computed
  get validateBirthDate() {
    return !!this.fullName || !!this.mailingAddress;
  }

  @computed
  get validateNaturalPerson() {
    return !!this.fullName || !!this.mailingAddress || !!this.birthDate;
  }
}
